function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M80.4916 9.74356H75.8945V0.246094H73.4111V11.8762H81.3636L80.4916 9.74356Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M59.7527 7.99969L62.236 2.50215L64.7194 7.99969H59.7527ZM63.6009 0.123047H60.7479L55.2788 11.8669H57.8854L58.8806 9.86696H65.4682L66.4635 11.8669H69.07L63.6009 0.123047Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.69179 4.62551C8.69179 5.9999 7.69655 7.12784 6.33165 7.12784H2.36015V2.87199V2.74877V2.24641H6.33165C7.69655 2.24641 8.56857 3.11843 8.69179 4.49281C8.69179 4.50229 8.69179 4.50229 8.69179 4.62551C8.69179 4.50229 8.69179 4.50229 8.69179 4.62551ZM11.3079 4.50229C11.3079 2.12319 9.56382 0.123221 7.20367 0H7.08045H0V11.7439H2.48337V8.87189H5.71554L7.82925 11.7439H10.6823L8.44535 8.62545C10.1894 8.12308 11.3079 6.50226 11.3079 4.50229Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M49.1935 6.62525C49.1935 8.37877 47.8286 9.75315 46.0846 9.75315C44.3405 9.75315 42.9756 8.37877 42.9756 6.62525V0.378906H40.6155V6.62525C40.6155 9.62046 43.0988 11.9996 46.0846 11.9996C49.0703 11.9996 51.5537 9.62046 51.5537 6.62525V0.378906H49.1935V6.62525Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0898 2.62531H29.0708V11.7436H31.5542V2.62531H35.5257V0.378906H25.0898V2.62531Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19.6302 0.246094H17.1469V11.7435H19.6302V0.246094Z",
  fill: "black"
});

function SvgRitualLogoUnpadded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 12,
    viewBox: "0 0 82 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRitualLogoUnpadded);
export default __webpack_public_path__ + "static/media/Ritual-Logo-Unpadded.9e815c98.svg";
export { ForwardRef as ReactComponent };